// ** React Imports
import { lazy } from 'react';

const SellerExtrasImport = [
  {
    path: 'extras',
    component: lazy(() =>
      import('views/seller-views/products/Extras/extra-group')
    ),
  },
  {
    path: 'extras/grouping',
    component: lazy(() =>
      import('views/seller-views/products/Extras/extra-grouping')
    ),
  },
  {
    path: 'extras/value',
    component: lazy(() =>
      import('views/seller-views/products/Extras/extra-group')
    ),
  },
  {
    path: 'catalog/extras/value',
    component: lazy(() =>
      import('views/seller-views/products/Extras/extra-group')
    ),
  },
];

export default SellerExtrasImport;
